import { MaterialLayer, Viewer } from '@stereograph/teiaviewer';
import {
  Group, Mesh, MeshBasicMaterial, SphereGeometry, Vector3,
} from 'three';

export class PathPointsHelper {
  private readonly group = new Group();
  private readonly geometry = new SphereGeometry(0.1, 12, 8);
  private readonly material = new MeshBasicMaterial({
    color: 0xff8c00,
    depthTest: true,
  });

  constructor(private readonly viewer: Viewer) {
    this.group.name = 'PathPointsHelper';
    this.attachToScene();
    this.viewer.signals.onSceneClear.connect(this.attachToScene);
  }

  addPoint(point: Vector3) {
    const marker = new Mesh(this.geometry, this.material);
    marker.position.copy(point);
    marker.layers.set(MaterialLayer.Tool);
    this.group.add(marker);
    this.viewer.requestRender();
  }

  removeLastPoint() {
    this.group.children.at(-1)?.removeFromParent();
    this.viewer.requestRender();
  }

  clear() {
    this.group.clear();
    this.viewer.requestRender();
  }

  dispose() {
    this.viewer.signals.onSceneClear.disconnect(this.attachToScene);
    this.viewer.scene.removeInternalObject(this.group);
    this.geometry.dispose();
    this.material.dispose();
    this.viewer.requestRender();
  }

  private readonly attachToScene = () => {
    this.viewer.scene.addInternalObject(this.group);
  };
}
